import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IClientPortalCookieService } from "services/ClientPortalCookieService";
import { ClientPortalCookiePreferencesModel } from "services/api/cplauthapi/CPLAuthAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

type CookiePreferencesState = {
  Loading: boolean;
  CookiePreferences: ClientPortalCookiePreferencesModel | null;
};

const initialState: CookiePreferencesState = {
  Loading: false,
  CookiePreferences: null,
};

export const CookiePreferencesSlice = createSlice({
  name: "CookiePreferences",
  initialState,
  reducers: {
    setCookiePreferences: (state, action) => {
      state.CookiePreferences = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCookiePreferences.pending, (state) => {
        state.Loading = true;
      })
      .addCase(updateCookiePreferences.fulfilled, (state) => {
        state.Loading = false;
      })
      .addCase(updateCookiePreferences.rejected, (state) => {
        state.Loading = false;
      });
  },
});

export const updateCookiePreferences = createAsyncThunk<void>(
  "CookiePreferences/UpdateAllCookiePreferences",
  async () => {
    const cookiesService = container.get<IClientPortalCookieService>(SERVICE_TYPES.ClientPortalCookieService);
    await cookiesService.updateCookiePreferences();
  }
);

export const { setCookiePreferences } = CookiePreferencesSlice.actions;
export const selectLoadingPreferences = (state: RootState) => state.cookiePreferences.Loading;
export const selectCookiePreferences = (state: RootState) => state.cookiePreferences.CookiePreferences;

export default CookiePreferencesSlice.reducer;
